"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var linear_progress_1 = require("@material/linear-progress");
//@ts-ignore
require("../theme.ts");
var LinearProgress = /** @class */ (function (_super) {
    __extends(LinearProgress, _super);
    function LinearProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinearProgress.prototype.installed = function () {
        new linear_progress_1.MDCLinearProgress(this.shadowRoot.querySelector('.mdc-linear-progress'));
        // progress.listen('MDCSlider:change', () => {
        //   this.fire('change', { value: slider.progress })
        // });
    };
    LinearProgress.prototype.render = function (props) {
        if (props.indeterminate) {
            return omi_1.h("div", { role: "progressbar", class: "mdc-linear-progress mdc-linear-progress--indeterminate" },
                omi_1.h("div", { class: "mdc-linear-progress__buffering-dots" }),
                omi_1.h("div", { class: "mdc-linear-progress__buffer" }),
                omi_1.h("div", { class: "mdc-linear-progress__bar mdc-linear-progress__primary-bar" },
                    omi_1.h("span", { class: "mdc-linear-progress__bar-inner" })),
                omi_1.h("div", { class: "mdc-linear-progress__bar mdc-linear-progress__secondary-bar" },
                    omi_1.h("span", { class: "mdc-linear-progress__bar-inner" })));
        }
        return (omi_1.h("div", __assign({ role: "progressbar" }, omi_1.extractClass(props, 'mdc-linear-progress', {
            "mdc-linear-progress--reversed": props.reversed
        })),
            omi_1.h("div", { class: "mdc-linear-progress__buffering-dots" }),
            omi_1.h("div", { class: "mdc-linear-progress__buffer", style: "transform: scaleX(" + props.buffer + ");" }),
            omi_1.h("div", { class: "mdc-linear-progress__bar mdc-linear-progress__primary-bar", style: "transform: scaleX(" + props.value + ");" },
                omi_1.h("span", { class: "mdc-linear-progress__bar-inner" })),
            omi_1.h("div", { class: "mdc-linear-progress__bar mdc-linear-progress__secondary-bar" },
                omi_1.h("span", { class: "mdc-linear-progress__bar-inner" }))));
    };
    LinearProgress.css = css;
    LinearProgress.defaultProps = {
        buffer: 1,
        value: 0
    };
    LinearProgress.propTypes = {
        buffer: Number,
        value: Number,
        indeterminate: Boolean,
        reversed: Boolean
    };
    LinearProgress = __decorate([
        omi_1.tag('m-linear-progress')
    ], LinearProgress);
    return LinearProgress;
}(omi_1.WeElement));
exports.default = LinearProgress;
